window.addEventListener("scroll", addStickyHeaderEfdc);

//function to add sticky header animations
function addStickyHeaderEfdc() {
  var header = document.getElementById("header");
  if (window.scrollY > 50) {
    header.classList.add("header--sticky");
  } else {
    header.classList.remove("header--sticky");
  }
}
